import SectionHeader from "../include/SectionHeader";

const TermsServices = () => {
  return (
    <section className="policies_page theme_content_section py-5">
      <div className="container">
        <SectionHeader title="Terms & Services" />

        <div className="row">
          <div className="col-lg-12">
            <div className="theme_content">
              <h4 id="h-1-about-company">1. About Company</h4>
              <p>
                These Terms & Services (these “Terms”) set out the legal terms that we require you to accept in order to access and use our website (the “Website”), and/or our services (the “Services”) offered by Lifeline Tulasi Hospital (Hyderabad) (“we”, “us”, “our”).
              </p>

              <h4>2. Definitions</h4>
              <p>
                In these Terms, the following terms (and their cognate forms)
                shall have the meanings assigned to them:
              </p>
              <ul>
                <li>
                  <strong>“Applicable Laws”</strong> means all laws, statutes,
                  rules, regulations, guidelines, policy(ies) and/or other
                  pronouncements having the force of law in India or other
                  applicable jurisdictions, including modifications or
                  amendments thereto.
                </li>
                <li>
                  <strong>“Client”</strong> means the legal person or individual
                  entering into an agreement with us for the Services.
                </li>
                <li>
                  <strong>“Party / Parties”</strong> means a party to these
                  Terms or both of us.
                </li>
                <li>
                  <strong>“Intellectual Property Rights”</strong> means patents,
                  trademarks, trade names, design rights, copyrights, database
                  rights, know-how and other intellectual property rights
                  (registered or unregistered) of whatever nature and wherever
                  arising.
                </li>
                <li>
                  Other defined terms may be set out in the full agreement as
                  needed.
                </li>
              </ul>

              <h4>3. Services Rendered</h4>
              <p>
                We shall render the Services with due care and diligence. We
                warrant that we will maintain adequate technical infrastructure
                to perform our obligations under these Terms. Our Services
                include but are not limited to healthcare services, diagnostics,
                treatment, consultations and ancillary services as offered
                through our hospital operations and the Website.
              </p>

              <h4>4. Client Obligations</h4>
              <p>In consideration of your use of our Services, you agree to:</p>
              <ul>
                <li>
                  Provide true, accurate, current and complete information as
                  required by us.
                </li>
                <li>
                  Promptly update your information to keep it true, accurate,
                  current and complete.
                </li>
                <li>
                  Comply with relevant approvals, authorisations and third-party
                  consents required for our Services.
                </li>
                <li>
                  Be responsible for securing your own account credentials,
                  device access, and not sharing them with third parties.
                </li>
                <li>
                  Use our Services only in accordance with Applicable Laws and
                  these Terms.
                </li>
              </ul>

              <h4>5. Duration and Termination</h4>
              <ul>
                <li>
                  These Terms commence upon your acceptance (by using the
                  Services) and continue until terminated in accordance with
                  these Terms.
                </li>
                <li>
                  Either Party may terminate these Terms by giving [–] days’
                  written notice (or as set out in a specific service
                  agreement).
                </li>
                <li>
                  We may immediately terminate or suspend access to the Services
                  if you breach these Terms, fail to pay applicable charges, or
                  become insolvent.
                </li>
                <li>
                  Upon termination, you must cease all use of our Services and
                  delete or return any working materials/data as required.
                </li>
              </ul>

              <h4>6. Disclaimer of Warranties</h4>
              <p>
                Our Services and Website are provided on an “as-is” and
                “as-available” basis. We make no representations or warranties
                of any kind regarding the Services, including that they will
                meet your requirements, will be uninterrupted, timely, secure or
                error-free, or that results will be accurate or reliable. We are
                not liable for any damages resulting from use or inability to
                use the Services except as required by law.
              </p>

              <h4>7. Intellectual Property</h4>
              <p>
                All rights, title and interest in and to the intellectual
                property used in connection with our Services or the Website,
                including software, content and documentation, remain our
                exclusive property (or the property of our licensors). You are
                granted only a limited, revocable, non-exclusive license to use
                the Services as set out in these Terms. You must not challenge
                our ownership or attempt to acquire rights you are not
                permitted.
              </p>

              <h4>8. Liability</h4>
              <p>
                To the fullest extent permitted by law, neither we nor our
                affiliates will be liable for any indirect, incidental,
                consequential, punitive or special damages, loss of profits,
                data or other losses, even if we have been advised of the
                possibility of such damage. Our total liability in any event
                shall be limited to the amount paid by you in the 12 months
                preceding the claim (or as otherwise agreed), except in cases of
                death or personal injury caused by our negligence or as
                otherwise prohibited by law.
              </p>

              <h4>9. Force Majeure</h4>
              <p>
                Neither Party shall be liable for any failure or delay in
                performance under these Terms if caused by circumstances beyond
                its reasonable control, including but not limited to natural
                disasters, strikes, wars, government actions, power failures,
                internet failures or similar events. The affected Party shall
                promptly notify the other and use reasonable efforts to resume
                performance.
              </p>

              <h4>10. Indemnity</h4>
              <p>
                You shall indemnify, defend and hold harmless Lifeline Tulasi Hospital (Hyderabad), its officers, directors, employees and agents against any claims, liabilities, losses, damages, costs and expenses (including legal fees) arising out of or in connection with your use of the Services or any breach of these Terms by you.
              </p>

              <h4>11. Confidentiality</h4>
              <p>
                You agree to keep confidential all non-public information
                disclosed to you under these Terms or in connection with the
                Services, and not to use or disclose it except as permitted. The
                confidentiality obligations survive termination of these Terms.
              </p>

              <h4>12. Relationship Between Parties</h4>
              <p>
                Nothing in these Terms shall create any employment, agency,
                partnership, joint-venture or fiduciary relationship between you
                and The Lifeline Tulasi Hospital (Hyderabad). Each Party acts solely on
                its own behalf.
              </p>

              <h4>13. Data Protection &amp; Privacy</h4>
              <p>
                You are responsible for ensuring that any personal data you
                submit or process via the Services or the Website is done so in
                compliance with applicable data protection laws. We will handle
                your personal data in accordance with our Privacy Policy
                published on the Website.
              </p>

              <h4>14. Updates to these Terms</h4>
              <p>
                We reserve the right to modify or update the Services, Website
                and/or these Terms at any time for any reason. Changes will be
                effective when posted on the Website and your continued use
                constitutes acceptance.
              </p>

              <h4>15. Severability, Waiver &amp; Survival</h4>
              <p>
                If any provision of these Terms is held invalid or
                unenforceable, the remaining provisions remain in full force and
                effect. No waiver of any right by either Party shall imply
                continuing waiver of similar rights. The rights and obligations
                intended to survive termination will so survive.
              </p>

              <h4>16. Governing Law &amp; Dispute Resolution</h4>
              <p>
                These Terms shall be governed by and construed in accordance
                with the laws of India. Any dispute arising under or relating to
                these Terms shall be subject to the jurisdiction of courts in
                Hyderabad, unless otherwise agreed in writing.
              </p>

              <h4>17. Contact Details</h4>
              <p>
                For any notices, billing or support relating to the Services under these Terms please contact: <br />
                <strong>Lifeline Tulasi Hospital</strong><br />
                A-12, EC Complex, ECIL X Road, Kushaiguda,<br />
                Hyderabad, Telangana, India <br />
                +91 99942 88800<br />
                +91 97919 88800<br />
                Do you have a Question? <br />
                infohyd@lih.bz
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsServices;
